import React from 'react';
import UnifiedAcceptInvite from '@components/UnifiedAcceptInvite';
import { getHostname } from '@services/utils';

const AcceptInvite: React.FC = () => {
  const hostname = getHostname();
  const theme = hostname.includes('dxscontrols') ? 'light' : 'dark';

  return <UnifiedAcceptInvite theme={theme} />;
};

export default AcceptInvite;
